// 🎯 기부/펀딩용
export const sortOptions = [
  { id: 1, label: "최신순" },
  { id: 2, label: "모금액 많은순" },
  { id: 3, label: "모금액 적은순" },
  { id: 4, label: "모금률 높은순" },
  { id: 5, label: "종료임박순" }
];

// 🛍️ 스토어 상품용
export const storeSortOptions = [
  { id: 1, label: "최신 등록순" },     // create_date DESC
  { id: 2, label: "낮은 가격순" },     // product_price ASC
  { id: 3, label: "높은 가격순" },     // product_price DESC
];